import { Routes } from "@angular/router";
import { ProductComponent } from "src/app/product/product/product.component";
import { WhishlistComponent } from "src/app/product/whishlist/whishlist.component";


export const PRODUCT_ROUTES: Routes = [
    {
      path: 'product/favourites', component: WhishlistComponent
    },
    {
      path: 'product/:id/:category', component: ProductComponent
    }

]